import { CardDef, CardTier, CardCategory, CardRarity } from '../types';

// ============================================
// 城 (castle) - パワーバランス型
// ============================================
const castleCards: CardDef[] = [
  {
    id: 'castle_001', name: '道化師', basePower: 1, category: 'castle', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBenchCheck',
      effect: {
        type: 'powerBoost', value: 3, description: 'ベンチにパワー1のカードがあればパワー+3',
        condition: { type: 'powerMatch', target: 'myBench', matchValue: 1, comparison: 'equal', minCount: 1 }
      }
    }]
  },
  {
    id: 'castle_002', name: '隠者', basePower: 2, category: 'castle', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBenchCheck',
      effect: {
        type: 'powerBoost', value: 2, description: 'ベンチにシティ属性のカードがなければパワー+2',
        condition: { type: 'categoryPresent', target: 'myBench', category: 'city', minCount: 0 }
      }
    }]
  },
  {
    id: 'castle_003', name: '馬小屋少年', basePower: 2, category: 'castle', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBenchCheck',
      effect: {
        type: 'powerBoost', value: 1, description: 'ベンチのパワー3のカード1枚につきパワー+1',
        condition: { type: 'powerMatch', target: 'myBench', matchValue: 3, comparison: 'equal', countMultiplier: true }
      }
    }]
  },
  { id: 'castle_004', name: 'ブタ', basePower: 3, category: 'castle', tier: 'A', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'castle_005', name: 'ナイト', basePower: 3, category: 'castle', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: {
        type: 'powerBoost', value: 1, description: '攻撃時相手トロフィー数だけパワー+1',
        condition: { type: 'opponentTrophyCount' }
      }
    }]
  },
  {
    id: 'castle_006', name: '鍛冶屋', basePower: 3, category: 'castle', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBench',
      effect: { type: 'powerBoost', value: 1, targetPlayer: 'self', targetCategory: 'city', description: 'ベンチにある場合シティ属性パワー+1' }
    }]
  },
  {
    id: 'castle_007', name: '魔術師', basePower: 4, category: 'castle', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBenchCheck',
      effect: {
        type: 'move', value: 1, destination: 'exile', targetPlayer: 'self', description: 'ベンチにパワー3以下があれば1枚除外へ',
        condition: { type: 'powerMatch', target: 'myBench', matchValue: 3, comparison: 'lessOrEqual', minCount: 1 }
      }
    }]
  },
  { id: 'castle_008', name: '馬', basePower: 5, category: 'castle', tier: 'B', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'castle_009', name: '吟遊詩人', basePower: 4, category: 'castle', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBench',
      effect: { type: 'powerBoost', value: 1, targetPlayer: 'self', description: 'ベンチにある場合自分キャラ攻撃+1' }
    }]
  },
  {
    id: 'castle_010', name: 'プリンス', basePower: 5, category: 'castle', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagLost',
      effect: { type: 'move', destination: 'exile', description: 'フラッグ喪失時除外へ' }
    }]
  },
  { id: 'castle_011', name: 'ドラゴン', basePower: 7, category: 'castle', tier: 'C', stockCount: 2, rarity: 'rare', abilities: [] },
];

// ============================================
// シティ (city) - 山札操作・トロフィー
// ============================================
const cityCards: CardDef[] = [
  { id: 'city_001', name: 'タレント', basePower: 2, category: 'city', tier: 'A', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'city_002', name: 'リポーター', basePower: 2, category: 'city', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onDeckCheck',
      effect: { type: 'swap', value: 2, swapMode: 'select', description: 'デッキから2枚見て上下に振り分け' }
    }]
  },
  { id: 'city_003', name: 'ドッグ', basePower: 3, category: 'city', tier: 'B', stockCount: 3, rarity: 'rare', abilities: [] },
  { id: 'city_004', name: 'チャンピオン', basePower: 4, category: 'city', tier: 'C', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'city_005', name: 'ファンバス', basePower: 6, category: 'city', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onTrophy',
      effect: {
        type: 'addTrophy', value: 2, description: 'トロフィー3以下なら★+2',
        condition: { type: 'trophyLessOrEqual', matchValue: 3 }
      }
    }]
  },
];

// ============================================
// 宇宙 (space) - カード追加・復活
// ============================================
const spaceCards: CardDef[] = [
  {
    id: 'space_001', name: 'レスキューポッド', basePower: 1, category: 'space', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagLost',
      effect: { type: 'revive', destination: 'deck', description: 'フラッグ喪失時山札に戻す' }
    }]
  },
  {
    id: 'space_002', name: 'AI', basePower: 2, category: 'space', tier: 'A', stockCount: 3, rarity: 'rare',
    abilities: [{
      timing: 'onBench',
      effect: {
        type: 'powerBoost', value: 1, targetPlayer: 'self', targetPower: 2,
        description: 'ベンチにある場合自分のパワー2キャラのパワー+1'
      }
    }]
  },
  { id: 'space_003', name: '牛', basePower: 3, category: 'space', tier: 'A', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'space_004', name: 'UFO', basePower: 3, category: 'space', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'addCard', addCardTier: 'A', destination: 'deckBottom', value: 2, description: 'A山札から2枚を見ずにデッキ下へ' }
    }]
  },
  {
    id: 'space_005', name: 'バンド', basePower: 3, category: 'space', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBench',
      effect: { type: 'powerBoost', value: 1, targetPlayer: 'self', targetCategory: 'space', description: 'ベンチにある場合宇宙属性パワー+1' }
    }]
  },
  {
    id: 'space_006', name: 'クローン', basePower: 4, category: 'space', tier: 'B', stockCount: 5, rarity: 'common',
    abilities: [{
      timing: 'onSelect',
      effect: { type: 'addTrophy', value: 1, description: '選択時★+1' }
    }]
  },
  { id: 'space_007', name: 'エイリアン', basePower: 5, category: 'space', tier: 'B', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'space_008', name: 'ホログラム', basePower: 4, category: 'space', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'addCard', addCardTier: 'B', destination: 'deckTop', value: 1, targetPlayer: 'opponent', description: 'B山札のカードを見ずに相手デッキ上へ' }
    }]
  },
  { id: 'space_009', name: 'スライム', basePower: 7, category: 'space', tier: 'C', stockCount: 2, rarity: 'rare', abilities: [] },
];

// ============================================
// 映画 (movie) - フラグ効果・攻撃強化
// ============================================
const movieCards: CardDef[] = [
  {
    id: 'movie_001', name: 'メイクアップアーティスト', basePower: 1, category: 'movie', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBench',
      effect: { type: 'powerBoost', value: 1, targetPlayer: 'self', targetCategory: 'movie', description: 'ベンチにある場合映画属性攻撃+1' }
    }]
  },
  {
    id: 'movie_002', name: 'ギャングスター', basePower: 2, category: 'movie', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'powerBoost', value: 2, description: '攻撃時パワー+2' }
    }]
  },
  { id: 'movie_003', name: 'ネコ', basePower: 3, category: 'movie', tier: 'A', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'movie_004', name: 'カウボーイ', basePower: 3, category: 'movie', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagGet',
      effect: { type: 'move', destination: 'bench', targetPlayer: 'opponent', description: 'フラッグ獲得時相手デッキ上をベンチへ' }
    }]
  },
  {
    id: 'movie_005', name: 'コミックキャラクター', basePower: 4, category: 'movie', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagLost',
      effect: { type: 'powerTemp', value: 2, description: 'フラッグ喪失時次の攻撃+2' }
    }]
  },
  {
    id: 'movie_006', name: 'ディレクター', basePower: 4, category: 'movie', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBench',
      effect: { type: 'powerBoost', value: 1, targetPlayer: 'self', targetCategory: 'movie', description: 'ベンチにある場合映画属性攻撃+1' }
    }]
  },
  { id: 'movie_007', name: 'ライオン', basePower: 5, category: 'movie', tier: 'B', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'movie_008', name: 'ヒーロー', basePower: 5, category: 'movie', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagGet',
      effect: { type: 'addTrophy', value: 3, description: 'フラッグ獲得時★+3' }
    }]
  },
  { id: 'movie_009', name: 'Tレックス', basePower: 7, category: 'movie', tier: 'C', stockCount: 2, rarity: 'rare', abilities: [] },
  {
    id: 'movie_010', name: 'ヴィラン', basePower: 10, category: 'movie', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'addCard', addCardTier: 'A', destination: 'deckTop', value: 1, description: 'A山札から1枚見ずにデッキ上へ' }
    }]
  },
];

// ============================================
// 難破船 (ship) - 山札操作・除外
// ============================================
const shipCards: CardDef[] = [
  {
    id: 'ship_001', name: 'マーマン', basePower: 1, category: 'ship', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBenchCheck',
      effect: {
        type: 'powerBoost', value: 3, description: 'ベンチに難破船属性があればパワー+3',
        condition: { type: 'categoryPresent', target: 'myBench', category: 'ship', minCount: 1 }
      }
    }]
  },
  {
    id: 'ship_002', name: 'トレジャー', basePower: 2, category: 'ship', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagGet',
      effect: { type: 'powerBoost', value: 2, description: 'フラッグ獲得時パワー+2' }
    }]
  },
  {
    id: 'ship_003', name: '船乗り', basePower: 2, category: 'ship', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onDeckCheck',
      effect: { type: 'swap', value: 1, swapMode: 'bottom', addCardSource: 'deck', description: 'デッキを見て1枚を一番下へ' }
    }]
  },
  { id: 'ship_004', name: 'オウム', basePower: 3, category: 'ship', tier: 'A', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'ship_005', name: 'ナビゲーター', basePower: 4, category: 'ship', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagLost',
      effect: { type: 'swap', value: 2, swapMode: 'select', description: 'フラッグ喪失時デッキ2枚を見て上下振り分け' }
    }]
  },
  { id: 'ship_006', name: 'サメ', basePower: 5, category: 'ship', tier: 'B', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'ship_007', name: 'サイレン', basePower: 6, category: 'ship', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'move', value: 1, destination: 'exile', targetPlayer: 'opponent', description: '相手ベンチ1枚を除外へ' }
    }]
  },
  { id: 'ship_008', name: 'クラーケン', basePower: 7, category: 'ship', tier: 'C', stockCount: 2, rarity: 'rare', abilities: [] },
  {
    id: 'ship_009', name: 'サブマリン', basePower: 9, category: 'ship', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onDeckCheck',
      effect: { type: 'move', value: 1, destination: 'exile', description: 'デッキ下のカードを除外へ' }
    }]
  },
];

// ============================================
// 幽霊 (ghost) - 除外・復活
// ============================================
const ghostCards: CardDef[] = [
  {
    id: 'ghost_001', name: '執事', basePower: 1, category: 'ghost', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'move', value: 2, destination: 'exile', description: 'ベンチ2枚まで除外へ' }
    }]
  },
  {
    id: 'ghost_002', name: 'スケルトン', basePower: 2, category: 'ghost', tier: 'A', stockCount: 8, rarity: 'common',
    abilities: [{
      timing: 'onFlagGet',
      effect: { type: 'powerBoost', value: 1, description: 'フラッグ獲得時パワー+1' }
    }]
  },
  { id: 'ghost_003', name: 'クモ', basePower: 3, category: 'ghost', tier: 'A', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'ghost_004', name: 'ゴースト', basePower: 1, category: 'ghost', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'move', value: 1, destination: 'exile', targetPlayer: 'opponent', description: '相手デッキから1枚を除外へ' }
    }]
  },
  {
    id: 'ghost_005', name: 'ティーンエイジャー', basePower: 2, category: 'ghost', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBenchCheck',
      effect: {
        type: 'powerBoost', value: 1, description: 'ベンチの幽霊属性1枚につきパワー+1',
        condition: { type: 'categoryPresent', target: 'myBench', category: 'ghost', countMultiplier: true }
      }
    }]
  },
  {
    id: 'ghost_006', name: 'ネクロマンサー', basePower: 3, category: 'ghost', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: {
        type: 'revive', destination: 'deckTop', value: 1, description: 'ベンチのパワー2をデッキ上へ',
        condition: { type: 'powerMatch', target: 'myBench', matchValue: 2 }
      }
    }]
  },
  { id: 'ghost_007', name: 'バット', basePower: 5, category: 'ghost', tier: 'B', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'ghost_008', name: 'バンパイア', basePower: 4, category: 'ghost', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBenchCheck',
      effect: {
        type: 'revive', destination: 'deckTop', value: 1, description: 'ベンチにB山札のカードがあればデッキ上へ',
        condition: { type: 'tierMatch', target: 'myBench', tier: 'B', minCount: 1 }
      }
    }]
  },
  {
    id: 'ghost_009', name: 'パンプキン', basePower: 5, category: 'ghost', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'move', value: 2, destination: 'exile', description: 'ベンチ2枚まで除外へ' }
    }]
  },
  { id: 'ghost_010', name: '人狼', basePower: 7, category: 'ghost', tier: 'C', stockCount: 2, rarity: 'rare', abilities: [] },
];

// ============================================
// 遊園地 (park) - 山札操作・トロフィー
// ============================================
const parkCards: CardDef[] = [
  {
    id: 'park_001', name: 'ピエロ', basePower: 1, category: 'park', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagGet',
      effect: { type: 'addTrophy', value: 2, description: 'フラッグ獲得時★+2' }
    }]
  },
  {
    id: 'park_002', name: 'ジャグラー', basePower: 2, category: 'park', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'swap', value: 3, swapMode: 'reorder', description: 'デッキ上3枚を見て並び替え' }
    }]
  },
  {
    id: 'park_003', name: '売り子', basePower: 2, category: 'park', tier: 'A', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onBench',
      effect: { type: 'powerBoost', value: 1, targetPlayer: 'self', targetCategory: 'park', description: 'ベンチにある場合遊園地属性パワー+1' }
    }]
  },
  { id: 'park_004', name: 'ポニー', basePower: 3, category: 'park', tier: 'A', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'park_005', name: '予知能力者', basePower: 4, category: 'park', tier: 'B', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onFlagLost',
      effect: { type: 'swap', value: 1, swapMode: 'top', addCardSource: 'deck', description: 'フラッグ喪失時デッキを見て1枚を上へ' }
    }]
  },
  { id: 'park_006', name: 'アヒル', basePower: 5, category: 'park', tier: 'B', stockCount: 3, rarity: 'rare', abilities: [] },
  {
    id: 'park_007', name: 'バンパーカー', basePower: 6, category: 'park', tier: 'C', stockCount: 4, rarity: 'common',
    abilities: [{
      timing: 'onPlay',
      effect: { type: 'swap', value: 3, swapMode: 'reorder', description: 'デッキ上3枚を見て並び替え' }
    }]
  },
  { id: 'park_008', name: 'テディベア', basePower: 7, category: 'park', tier: 'C', stockCount: 2, rarity: 'rare', abilities: [] },
];

// 全カードをエクスポート
export const ALL_CARDS: CardDef[] = [
  ...castleCards,
  ...cityCards,
  ...spaceCards,
  ...movieCards,
  ...shipCards,
  ...ghostCards,
  ...parkCards,
];

// カテゴリ別取得
export function getCardsByCategory(category: CardCategory): CardDef[] {
  return ALL_CARDS.filter(c => c.category === category);
}

// ティア別取得
export function getCardsByTier(tier: CardTier): CardDef[] {
  return ALL_CARDS.filter(c => c.tier === tier);
}

// ID検索
export function getCardById(id: string): CardDef | undefined {
  return ALL_CARDS.find(c => c.id === id);
}
